/* Shared, on-demand storefront catalog. No requests until a component asks. */
(() => {
  if (window.PlainSightDiscovery) return;
  const cache = new Map();
  const timedFetch = async (url) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error('Discovery request failed');
      return await response.text();
    } finally { clearTimeout(timer); }
  };
  const loadCatalog = async (catalogUrl) => {
    let url = new URL(catalogUrl, location.origin);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const section = url.searchParams.get('section_id');
    const visited = new Set();
    const products = new Map();
    // Four 250-product pages cap discovery at 1,000 products. Only metadata is
    // fetched; images load on display. Small catalogs need just one roundtrip.
    while (url && visited.size < 4) {
      if (url.origin !== location.origin || visited.has(url.href)) break;
      visited.add(url.href);
      const html = await timedFetch(url.href);
      const dataNode = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ps-catalog]');
      if (!dataNode) throw new Error('Discovery data unavailable');
      const data = JSON.parse(dataNode.textContent);
      if (!Array.isArray(data.products)) throw new Error('Invalid discovery data');
      data.products.forEach(product => products.set(String(product.id), product));
      if (!data.next) break;
      url = new URL(data.next, location.origin);
      url.searchParams.set('section_id', section);
      if (preview) url.searchParams.set('preview_theme_id', preview);
    }
    return [...products.values()];
  };
  window.PlainSightDiscovery = {
    load({ catalogUrl, rulesUrl }) {
      const key = catalogUrl + '|' + rulesUrl;
      const stored = cache.get(key);
      if (stored && Date.now() - stored.time < 300000) return stored.promise;
      const promise = Promise.all([loadCatalog(catalogUrl), timedFetch(rulesUrl).then(JSON.parse)])
        .then(([products, rules]) => ({ products, engine: window.PlainSightRecommendations.create(rules) }))
        .catch(error => { cache.delete(key); throw error; });
      cache.set(key, { time: Date.now(), promise });
      return promise;
    }
  };
})();
